import { LzTNavItem, LzTNavItems } from './types';
import { useLzFCheckRights } from '@lz/services/Utils';

export enum LzENavNodeVisibileCheck {
  VISIBLE = 1,
  HIDDEN = 2,
  CHECK_FURHTER = 3,
}

export const useLzFGetVisibleNavigation = () => {
  const checkRights = useLzFCheckRights();

  return (navItems: LzTNavItems): LzTNavItems =>
    lzFGetVisibleNavigation(navItems, checkRights);
};

export const lzFGetVisibleNavigation = (
  navItems: LzTNavItems,
  checkRights: (rightsPath: string) => boolean,
  isNodeVisibleCallback?: (navItem: LzTNavItem) => LzENavNodeVisibileCheck
): LzTNavItems => {
  const outNav: LzTNavItems = [];

  for (const navItem of navItems) {
    const retItem = lzFGetVisibleNavItem(
      navItem,
      checkRights,
      isNodeVisibleCallback
    );

    if (retItem) {
      outNav.push(retItem);
    }
  }

  return outNav;
};

const lzFGetVisibleNavItem = (
  navItem: LzTNavItem,
  checkRights: (rightsPath: string) => boolean,
  isNodeVisibleCallback?: (navItem: LzTNavItem) => LzENavNodeVisibileCheck
): LzTNavItem | null => {
  // console.log('Checking Nav Item Rights:', navItem);

  const retNavItem: LzTNavItem = Object.assign({}, navItem);

  // If a callback is defined to check the node visibility
  if (typeof isNodeVisibleCallback !== 'undefined') {
    // Call the callback
    const visibility = isNodeVisibleCallback(retNavItem);

    // If it decides to show it
    if (visibility === LzENavNodeVisibileCheck.VISIBLE) {
      return retNavItem;
    }

    // If it decides to hide it
    if (visibility === LzENavNodeVisibileCheck.HIDDEN) {
      return null;
    }

    // If it decides to check further then continue below to do so
  }

  // If rights path is NOT defined, then it should be allowed throughout
  if (
    typeof retNavItem.rightsPath === 'undefined' ||
    '' === retNavItem.rightsPath
  ) {
    return retNavItem;
  }

  // Check rights of this node
  const thisNodeAllowed = checkRights(retNavItem.rightsPath);

  // If this is the leaf node then conclude the evaluation of rights
  if (
    typeof retNavItem.children === 'undefined' ||
    retNavItem.children.length < 1
  ) {
    return thisNodeAllowed ? retNavItem : null;
  }

  // It has children, so we go deep inside and check them each
  const children: LzTNavItem[] = [];
  for (const child of retNavItem.children) {
    const retChild = lzFGetVisibleNavItem(
      child,
      checkRights,
      isNodeVisibleCallback
    );
    if (retChild) {
      children.push(retChild);
    }
  }

  // If the collected children are empty then conclude the evaluation of rights
  if (children.length < 1) {
    return thisNodeAllowed ? retNavItem : null;
  }

  // Else update the children to the current node and return
  retNavItem.children = children;
  return retNavItem;
};
